import { CategoryView } from '../types/entity-types';

type CategoryChild = {
  id: string;
  name: string;
  icon: string;
};

type CategoryGroup = {
  name: string;
  children: CategoryChild[];
};

type GetGroupedCategoriesArgs = {
  categories: CategoryView[];
};

export const getGroupedCategories = ({ categories }: GetGroupedCategoriesArgs): CategoryGroup[] => {
  const createChildCategory = (category: CategoryView): CategoryChild => ({
    id: category.id,
    name: category.level2,
    icon: category.icon,
  });

  return categories.reduce<CategoryGroup[]>((acc, category) => {
    const existingGroup = acc.find((group) => group.name === category.level1);

    if (existingGroup) {
      existingGroup.children.push(createChildCategory(category));
    } else {
      acc.push({
        name: category.level1,
        children: [createChildCategory(category)],
      });
    }

    return acc;
  }, []);
};
